module.exports = __webpack_public_path__ + "/img/Radial-Led-Round-Labeled-zobJDo.svg";